module.exports = __webpack_public_path__ + "static/img/123.7d74e6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsCenteru/123.jpg
// module id = yM47
// module chunks = 1